import { yup } from '@core/middlewares'

export const invoicesFilterFormValidationSchema = yup.object().shape({
    company_id: yup.string(),
    final_total_from: yup.number().nullable(),
    final_total_to: yup
        .number()
        .nullable()
        .when('final_total_from', ([fromValue], schema) => {
            return fromValue ? schema.min(fromValue) : schema
        }),
    start_date: yup.date(),
    end_date: yup.date().when('start_date', ([startedDate], schema) => {
        return startedDate ? schema.min(startedDate) : schema
    }),
})
